import { PostHogProvider as BasePostHogProvider } from '@posthog/react'
import type { ReactNode } from 'react'
import { env } from '@/env.client'

interface PostHogProviderProps {
  readonly children: ReactNode
}

const posthogOptions = {
  api_host: env.VITE_POSTHOG_HOST,
  defaults: '2026-01-30',
} as const

const isProduction = import.meta.env.PROD
const hasPostHogToken = Boolean(env.VITE_POSTHOG_PROJECT_TOKEN)
const isPostHogEnabled = isProduction && hasPostHogToken

export function PostHogProvider({ children }: PostHogProviderProps) {
  if (!isPostHogEnabled) return <>{children}</>

  return (
    <BasePostHogProvider
      apiKey={env.VITE_POSTHOG_PROJECT_TOKEN!}
      options={posthogOptions}
    >
      {children}
    </BasePostHogProvider>
  )
}
